// extracted by mini-css-extract-plugin
module.exports = {"ctaSection":"simple-header-section_ctaSection__UQr6E","heading":"simple-header-section_heading__tiJPo","subtitle":"simple-header-section_subtitle__JUGzW"};